import React, { useEffect, useState } from 'react';
import { NavAuth } from './style';
import { Link } from 'react-router-dom';
import { Popover } from '../../ui/popup/popup';

const flagMap = {
    english: require('../../../static/img/flag/english.png'),
    germany: require('../../../static/img/flag/germany.png'),
};

const Language = () => {
    const [language, setLanguage] = useState('en');
    const [flag, setFlag] = useState('english');

    useEffect(() => {
        const storedLang = localStorage.getItem('language') || 'en';
        const langMap = {
            en: 'english',
            de: 'germany',
        };

        setLanguage(storedLang);
        setFlag(langMap[storedLang] || 'english');
    }, []);

    const changeLanguage = (langKey, flagName) => {
        setLanguage(langKey);
        setFlag(flagName);
        localStorage.setItem('language', langKey);
    };

    const country = (
        <NavAuth>
            <Link onClick={() => changeLanguage('en', 'english')} to="#">
                <img src={flagMap.english} alt="English" />
                <span>English</span>
            </Link>
            {/* <Link onClick={() => changeLanguage('de', 'germany')} to="#">
                <img src={flagMap.germany} alt="Germany" />
                <span>Germany</span>
            </Link> */}
        </NavAuth>
    );

    return (
        <div className="language">
            <Popover placement="bottomRight" content={country} action="click">
                <Link to="#" className="head-example">
                    <img src={flagMap[flag]} alt={flag} style={{ width: 24, borderRadius: '10%' }} />
                </Link>
                <div className="lang-selector">
                    <span>{language.toUpperCase()}</span>
                </div>
            </Popover>
            
        </div>
    );
};

export default Language;
